import Box from '@mui/material/Box';

const Row = ({children, sx={}}) => {
  sx = {display: 'flex', flexDirection: 'row', alignItems: 'center',...sx};
  return (
    <Box sx={sx}>{children}</Box>
  );
}
export default Row;
